import { Box } from "@mui/material";
import type { FC } from "react";
import { BADGE } from "@/theme/tokens";
import MetaChip from "@/ui/Badges/MetaChip";
import type { OutreachScoredPerson } from "@/utils/models";
import { TEXT_INSET } from "./outreachRowLayout";
import { type OutreachCopy, orderedFactorsOf } from "./useOutreachCopy";

/** What moved them up or down the line, one chip per factor: green helps, amber holds back, doubled arrows for strong pulls. */
export const OutreachWhyChips: FC<{ person: OutreachScoredPerson; copy: OutreachCopy; dataTestId: string }> = ({ person, copy, dataTestId }) => (
	<Box data-testid={`${dataTestId}-why`} sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, ps: TEXT_INSET, pe: 0.5, pb: 1.25 }}>
		{orderedFactorsOf(person).map((factor) => {
			const up = factor.strength > 0;
			const arrow = (up ? "↑" : "↓").repeat(Math.abs(factor.strength));
			return (
				<MetaChip
					key={factor.kind}
					size="small"
					tone={up ? "success" : "warning"}
					label={`${arrow} ${copy.factorText(factor)}`}
					sx={{ borderRadius: BADGE.PILL_RADIUS_FULL }}
				/>
			);
		})}
	</Box>
);
